"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ServiceAreaFilterGroups = void 0;
var ServiceAreaFilterGroups;
(function (ServiceAreaFilterGroups) {
    ServiceAreaFilterGroups["Teams"] = "team_ids";
})(ServiceAreaFilterGroups = exports.ServiceAreaFilterGroups || (exports.ServiceAreaFilterGroups = {}));
//# sourceMappingURL=service-area.consts.js.map